import React, { useEffect, useState } from 'react';

const UserContext = React.createContext();

const UserContextProvider = ({ children, user, config }) => {
  const [orgType, setOrgType] = useState('');

  /**
   * Get organization type
   * @param {object} user
   */
  const getOrganizationType = (user, config) => {
    const plainOrg = config?.subscription?.enabled || false;
    const msOwnerOrg = user?.organization?.organization_type === 'OWNER';

    if (plainOrg) {
      setOrgType('plainOrg');
    } else if (msOwnerOrg) {
      setOrgType('msOwnerOrg');
    } else {
      setOrgType('msServiceOrg');
    }
  };

  useEffect(() => {
    if (user && user.organization) {
      getOrganizationType(user, config);
    } else {
      setOrgType('');
    }
  }, [user, config]);

  return <UserContext.Provider value={{ orgType }}>{children}</UserContext.Provider>;
};

export { UserContext, UserContextProvider };
